import { Button, Heading, Text } from '@ksyos/design-system';
import { useNavigate } from '@ksyos/router';
import { Figure } from '../../../elements/atoms/figure/Figure';
import { Container } from '../../../elements/molecules/container/Container';
import { HelpFooter } from '../../../elements/molecules/helpFooter/HelpFooter';
import { Main } from '../../../elements/molecules/main/Main';
import { PageSection } from '../../../elements/molecules/pageSection/PageSection';
import { Stack } from '../../../elements/molecules/stack/Stack';
import { Header } from '../../../elements/organisms/header/Header';
import { PageWrapper } from '../../../elements/organisms/pageWrapper/PageWrapper';

export function QuestionnaireNotAvailable() {
    const navigate = useNavigate();

    return (
        <PageWrapper fullHeight={true}>
            <Header backUrl="/" />
            <Main className="center-aligned">
                <Container isFluidOnMobile={true}>
                    <PageSection
                        align="center"
                        bgColor="white"
                    >
                        <Figure
                            alt="No questionnaire available"
                            imageUrl="/assets/images/somnology/questionnaires/questionnaire-not-available.svg"
                            imgClassName="centered-image"
                        />

                        <Stack>
                            <Heading
                                as="h2"
                                size="xlarge"
                            >
                                Vragenlijst niet beschikbaar
                            </Heading>
                        </Stack>

                        <Stack>
                            <Text
                                className="shorter"
                                style={{ margin: '0 auto' }}
                            >
                                Het lijkt erop dat de link die je hebt gebruikt om hier te komen verlopen is. Gebruik de
                                meest recente link die je van Ksyos in je mail hebt gekregen om de vragenlijsten te
                                kunnen invullen.
                            </Text>
                        </Stack>

                        <Stack>
                            <Button onClick={() => navigate('/')}>Naar Mijn Ksyos</Button>
                        </Stack>

                        <Stack>
                            <HelpFooter />
                        </Stack>
                    </PageSection>
                </Container>
            </Main>
        </PageWrapper>
    );
}
